export default __webpack_public_path__ + "static/media/idan-erlicman.c7b5a4fe.png";